<template>
  <layout-main-inner
    v-loading="loading"
    title="账号管理">
    <div slot="action">
      <!-- <el-button
        type="primary"
        @click="selectitem">
        新增账号
      </el-button> -->
      <el-dropdown>
        <el-button
          type="primary"
          style="margin-left: 10px;">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="selectitem">新增员工账号</el-dropdown-item>
          <!-- <el-dropdown-item @click.native="()=> {additem({},2)}">新增普通账号</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.staffName"
          clearable
          placeholder="请输入姓名"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          min-width="80"
          label="账号"
          prop="account"> </el-table-column>
        <el-table-column
          min-width="80"
          label="姓名"
          prop="staffName"> </el-table-column>
        <el-table-column
          v-if="userInfo.userType === 506"
          min-width="200"
          label="业务范围"
          prop="servicePermmisionsStr">
        </el-table-column>
        <el-table-column
          label="功能"
          min-width="480"
          prop="functionsStr">
        </el-table-column>
        <el-table-column
          label="账号状态"
          width="80"
          fixed="right"
          prop="lockFlag">
          <template slot-scope="{ row }">
            <el-switch
              v-if="row.isAdmin !== 1"
              :value="row.lockFlag"
              :active-value="0"
              :inactive-value="1"
              @change="(e)=> {switchChange(row, e)}">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="110">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.isAdmin !== 1"
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-dropdown v-if="row.isAdmin !== 1">
              <el-button
                style="margin-left: 10px;"
                type="text">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="resetpassword(row)">密码重置</el-dropdown-item>
                <el-dropdown-item @click.native="setStaffRoom(row)">鉴定单数据范围设置</el-dropdown-item>
                <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
    <user-select-modal
      ref="select"
      :callback="(r) => { additem(r,1); }" />
    <edit-user-modal
      ref="user"
      :callback="() => { getlist(); }" />

    <set-staff-room-modal ref="staffRoom" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import UserSelectModal from './user-select-modal.vue'
import EditUserModal from './edit-user-modal.vue'
import Staffroom from '@/service/staffroom'
import SetStaffRoomModal from './set-staff-room-modal.vue'
export default {
  name: 'AccountsIndex',
  components: { UserSelectModal, EditUserModal, SetStaffRoomModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, staffName: '', operTypes: [0] },
      needSelect: true
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.needSelect = this.$route.path !== '/staffs'
    this.getlist()
  },
  methods: {
    setStaffRoom(row) {
      const { staffId, staffName } = row
      this.loading = true
      Staffroom.getstaffrooms({ staffId, pageSize: 100 })
        .then(res => {
          this.loading = false
          const { result, message, records } = res.data
          if (result === 0) {
            this.$refs.staffRoom.fetch({ staffId, staffName, roomIds: records.map(item => item.roomId) })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    switchChange(row, e) {
      console.log(e)
      this.$confirm(`此操作将${e === 1 ? '禁用' : '启用'}该鉴定师账号, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        const dispatch = e === 1 ? 'lockstaff' : 'unlockstaff'
        this.$store.dispatch(`appraise/${dispatch}`, {
          payload: { staffId: row.staffId },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    resetpassword(row) {
      this.$confirm('您确定重置该商家的登录密码?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('account/resetpassword', {
            payload: { account: row.account },
            success: () => {
              this.loading = false
              this.$message.success('重置密码成功')
              this.getlist(1)
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    updateitem(row) {
      const operations = {}
      const functions = row.functions || []
      functions.forEach((i) => {
        // i.operations.forEach((s) => {
        //   operations.push(s.operation)
        // })
        operations[i.funcId] = i.operations.map(s => s.operation)
        // {
        //   // operations: i.operations,
        //   operation: i.operations.map(s => s.operation)
        // }
      })
      this.$refs.user.update({
        staffId: row.staffId,
        orgId: row.orgId,
        staffName: row.staffName,
        account: row.account,
        servicePermmisions: (row.servicePermmisions || []).map((i) => i.serviceId),
        functions: row.functions.map((i) => i.funcId),
        mobile: row.mobile,
        operations
      })
    },
    selectitem() {
      if (this.needSelect) {
        this.$refs.select.fetch()
      } else {
        this.additem({}, 0)
      }
    },
    additem(row = {}, type) {
      console.log(row)
      this.$refs.user.add(row, type)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该账号?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('account/deletestaff', {
            payload: { staffId: row.staffId },
            success: () => {
              this.loading = false
              this.getlist()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getstaffs', {
        payload: { ...this.config, orgId: this.userInfo.orgId },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              functionsStr: i.functions.map(s => s.funcName).join('，'),
              servicePermmisionsStr: i.servicePermmisions.map(s => s.serviceName).join('，')
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
